<div class="_ratings-count-statistic-component">

	<p>{{'STATISTICS.RATINGS.COUNT' | translate}}<b>{{numberOfRatings}}</b></p>

</div>



